<template>
  <div>
    <div class="flex flex-wrap items-center justify-end mb-4">
      <b-button
        v-permission="'fee_plans.create'"
        variant="primary"
        @click="$router.push('/financial/fee_plans/create')">
        <feather-icon icon="PlusIcon" class="mr-50"/>
        <span class="align-middle">{{ $t('fee_plans.new') }}</span>
      </b-button>
    </div>

    <Grid
      :service="service"
      route_name="financial/fee_plans"
      route_grid_path="/grid"
      order_column="id"
      ref="grid"
    >
      <template v-slot:gridThead>
        <vs-th key="id" sort-key="id">ID</vs-th>
        <vs-th key="name" sort-key="name">{{ $t('fee_plans.name') }}</vs-th>
        <vs-th key="is_default">{{ $t('fee_plans.default') }}</vs-th>
        <vs-th key="active_version">{{ $t('fee_plans.active_version') }}</vs-th>
        <vs-th key="establishments_count">{{ $t('fee_plans.establishments') }}</vs-th>
        <vs-th key="created_at" sort-key="created_at">{{ $t('fee_plans.created_at') }}</vs-th>
      </template>

      <template v-slot:gridData="props">
        <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in props.data">
          <vs-td width="5%" key="id">
            <div>{{ tr.id }}</div>
          </vs-td>
          <vs-td width="30%" key="name">
            <div class="font-semibold">{{ tr.name }}</div>
            <small class="text-muted">{{ tr.description }}</small>
          </vs-td>
          <vs-td width="10%" key="is_default">
            <vs-chip v-if="tr.is_default" color="primary" class="text-base">
              {{ $t('fee_plans.default') }}
            </vs-chip>
            <span v-else>—</span>
          </vs-td>
          <vs-td width="12%" key="active_version">
            <div v-if="tr.active_version">
              v{{ tr.active_version.version }}
              <small class="text-muted d-block">
                {{ tr.active_version.effective_from ? $utils.format.date(tr.active_version.effective_from) : '' }}
              </small>
            </div>
            <vs-chip v-else color="warning" class="text-base">{{ $t('fee_plans.no_active_version') }}</vs-chip>
          </vs-td>
          <vs-td width="13%" key="establishments_count">
            <div>{{ tr.is_default ? $t('fee_plans.all_without_custom') : tr.establishments_count }}</div>
          </vs-td>
          <vs-td width="15%" key="created_at">
            <div>{{ $utils.format.date(tr.created_at) }}</div>
          </vs-td>
          <vs-td width="15%">
            <span class="flex">
              <feather-icon
                v-permission="'fee_plans.edit'"
                icon="EditIcon"
                svg-classes="h-5 w-5 mr-4 hover:text-primary cursor-pointer"
                @click="$router.push(`/financial/fee_plans/${tr.id}/edit`)"/>
              <feather-icon
                v-if="!tr.is_default"
                v-permission="'fee_plans.delete'"
                icon="Trash2Icon"
                svg-classes="h-5 w-5 hover:text-danger cursor-pointer"
                @click="props.destroy(tr)"/>
            </span>
          </vs-td>
        </vs-tr>
      </template>
    </Grid>
  </div>
</template>

<script>
import Grid from '@/components/Grid.vue'
import FeePlanService from '@/services/api/FeePlanService'

export default {
  components: {
    Grid
  },
  data() {
    return {
      service: null
    }
  },
  beforeMount() {
    this.service = FeePlanService.build(this.$vs)
  }
}
</script>
